import Box from './components/Box'
import Btn from './components/Btn'
import Filterbtn from './components/Filterbtn'
import FetchingContent from './components/FetchingContent'
import Error404 from './components/Error404'

var mixins = {}

//------------------------------------------------------------------------------

mixins.db = {
  computed: {
    
    //my_user(){ return this.$store.getters['users/my_user'] },
		//is_admin(){ return ( this.$store.getters['users/my_user'] && this.$store.getters['users/my_user'].admin ) },
    //show_beta_content(){ return this.$store.state.show_beta_content },
    
  },
}

//------------------------------------------------------------------------------

  mixins.generic = {

      components: {
        Box, Btn, Filterbtn,    
        FetchingContent, Error404, 
      },

      computed: {

        route(){ return this.$store.state.route.current },
        
        route_tags(){ return ( this.route.meta && this.route.meta.tags && this.route.meta.tags ) || {} },

        domain(){ return this.$store.state.domain },

        is_site(){ return this.$store.getters.is_site },
        is_site_scoop(){ return this.$store.getters.is_site_scoop },
        is_site_am(){ return this.$store.getters.is_site_am },
        is_site_scoopsocial(){ return this.$store.getters.is_site_scoopsocial },


        metrics(){ return this.$store.state.metrics },
        base_url(){ return this.$store.state.base_url },

        site_base_url(){
          if( this.is_site_am ) return this.$store.state.base_url_am
          return this.$store.state.base_url
        },

        is_fetching_content(){ return this.$store.state.is_fetching_content },        
        loggedin_user(){ return this.$store.state.loggedin_user },

        is_local(){ return this.$store.getters.is_local },
        is_live(){ return this.$store.getters.is_live },

        is_milk(){ return this.$store.getters.is_milk },

        active_casting(){ return this.$store.getters.active_casting },

        editing_blocks(){ return this.$store.state.editing_blocks },

        loaded_page(){ return this.$store.state.loaded_page },
        
        loaded_model(){ return this.$store.state.loaded_model },
        loaded_artist(){ return this.$store.state.loaded_artist },
        loaded_influencer(){ return this.$store.state.loaded_influencer },
        
        loaded_page_id(){
          if( !this.$store.state.loaded_page ) return
          return this.$store.state.loaded_page.id
        },

        editable_layoutblocks(){

          var rp = this.route.parts
          var rt = this.route_tags

          var loaded_page = this.$store.state.loaded_page
          var loaded_model = this.$store.state.loaded_model
          var loaded_artist = this.$store.state.loaded_artist

          if ( this.$store.state.editing_blocks ) return false
          if ( rt.models_list ) return false
          if ( rt.artists_list ) return false
          if ( rt.influencers_list ) return false
          
          if ( 
            rt.page && loaded_page && 
            loaded_page.content_type && loaded_page.content_type == 'blocks'
          ) return true
          
          if ( rt.model_single && loaded_model ) {
            if( !rp[3] || rp[3] != 'full-book' ) return true
          }

          if( rt.artist_single && loaded_artist ) {
            if ( !rp[3] || rp[3] != 'biography' ) return true
          }

          return false
        },

      },

      methods: {

        openURLNewWindow(url){ window.open(url, '_blank') },

        //msg(input){ eventBus.$emit('msg',input) },

        spinner(boolean){
          if( boolean == undefined ) boolean = !this.$store.state.small_spinner
          this.$store.commit('set_small_spinner',boolean)
        },
  
        big_spinner(boolean){ 
          if( boolean == undefined ) boolean = !this.$store.state.big_spinner
          this.$store.commit('set_big_spinner',boolean)
        },
        
        trackView(location){ eventBus.$emit('trackView',location) },
        trackEvent(input){ eventBus.$emit('trackEvent',input) },


        msg(input){
          var msg = { text:input }
          this.$store.commit('push_msg', msg)
        },

        alert(input) { this.msg(input) },

        kill_msg(){
          this.$store.commit('kill_msg')
        },
        
    	  toast(input){ eventBus.$emit('toast',input) },
        openTimelogger(input){ eventBus.$emit('openTimelogger',input) },

        goto(to){ this.$router.push(to) },

        getModelById(id){ return this.$store.getters.getById('model',id) },
        getClientById(id){ return this.$store.getters.getById('client',id) },
        
        modal_open(input){ this.$store.commit('modal_open',input) },
        modal_close(modal){ this.$store.commit('modal_close',modal) },

        findbox_open(input){ this.$store.commit('findbox_open',input) },
        findbox_close(){ this.$store.commit('findbox_close') },

        medialib_open(input){ if(!input) input = {}; input.modal = 'media_lib'; this.$store.commit('modal_open',input) },        

        has_route_tag(tag) {
          if( !this.route ) return false
          if( !this.route.meta ) return false
          if( !this.route.meta.tags ) return false
          if( !this.route.meta.tags[tag] ) return false
          return false
        },

        triggerIconSignal( icon ){
          if( !icon ) icon = 'check'
          eventBus.$emit('triggerIconSignal',icon)
        },

        mediaUrl( media_id, size, ext, randomcachebuster ){

          if( !size ) size = 900
          
          var size2 = size + 'x' + size
          if( size == 'original' ) size2 = size

          if( !ext ) ext = 'jpg'

          var url = this.$store.state.base_url + 'uploads/media/' + media_id + '_'+size2+'.'+ext

          if( randomcachebuster ) url += '?' + parseInt(Math.random()*999)
          
          return url

        },

        mediaVideoUrl(media){
          if( media.type == 'youtube' ) return 'https://www.youtube.com/watch?v=' + media.video_slug
          if( media.type == 'vimeo' ) return 'https://vimeo.com/' + media.video_slug
        },


        mediaVideoThumbnailImg(media) {

          if( media.type == 'vimeo' ) {
            //var img_url = 'https://press.vimeo.com/assets/vimeo_logo_dark_thumb-a2f7a9e24e62c1e7fac4b4f2885a18cc5da3136cac3432b378a866a3581d6be7.jpg';
            //var img_url = 'https://banner2.kisspng.com/20180705/rfo/kisspng-vimeo-logo-download-5b3e0da0107469.3502600215307933760674.jpg'				
            //var img_url = 'https://hutt.co/images/video-poster.png'
            var img_url = 'https://scoopmodels.com/api/fetch_vimeo_video_thumbnail?vimeo_id='+media.video_slug
          }
    
          if( media.type == 'youtube' ) {
            if( !media.video_slug ) return
            var img_url = 'https://img.youtube.com/vi/'+media.video_slug+'/0.jpg'				
          }

          return img_url

        },

        mediaVideoThumbnailImgFromMediaId( media_id, size ){
          if( !size ) size = 300
          return this.base_url + 'api/media_get_thumbnail?media_id='+media_id+'&output=img&size='+size
        },



        editLayout(){
          this.$store.commit('set_editing_blocks', true)
        },

        setMetrics(metrics){ this.$store.commit('setMetrics', metrics) },

        setDocumentTitle( pagetitle ){

          var sitetitle = 'Scoop Models'
          if( window.is_site_am ) sitetitle = 'A Management'
          if( this.$store.getters.is_site_scoopsocial ) sitetitle = 'Scoop Social'

          var title = sitetitle

          if( pagetitle && pagetitle.length ) title = pagetitle + ' — ' + sitetitle
          
          document.title = title

        },

//----------------------------------------------------------------------------        

        casting_item_add(item){
          
          if( !this.$store.state.castings.length ) this.$store.commit('create_new_empty_casting')

          this.$store.commit('casting_item_add', item)

          //eventBus.$emit('set_show_added_to_casting_modal', true)
          //setTimeout(()=>{
          //  eventBus.$emit('set_show_added_to_casting_modal', false)
          //}, 3500)

        },

//----------------------------------------------------------------------------        

  set_generic_field_editor(input){
    this.$store.commit('set__generic_field_editor', input)
  },

//----------------------------------------------------------------------------        

        medialib_visibles(input) {
          this.$store.commit('set_medialib_visibles',input)          
        },

//----------------------------------------------------------------------------        

        // generic fetch method
        fetch( endpoint, input, settings ){
          settings.endpoint = endpoint
          settings.input = input
          this.$store.dispatch('fetch',settings)
        },

        // authenticated shorthand fetching
        fetch_authed( endpoint, input, settings ){
          settings.endpoint = endpoint
          settings.input = input
          settings.auth = true
          if( !settings.onAuthFail ) settings.onAuthFail = this.onFetchAuthFail
          this.$store.dispatch('fetch',settings)
        },

        // on auth fails - normally you would sign out and reload 
        onFetchAuthFail(){
          this.$store.dispatch('user_logout')
          window.location.reload()
        },

//----------------------------------------------------------------------------        

        handleDynamicHtmlClicks($event){
          let { target } = $event
          while (target && target.tagName !== 'A') target = target.parentNode

          var internallink = false

          if( target.href && target.href.indexOf('https://scoopmodels.com') !== -1 ) internallink = true
          if( target.href && target.href.indexOf('https://www.scoopmodels.com') !== -1 ) internallink = true
          if( target.href && target.href.indexOf('https://a-management.eu') !== -1 ) internallink = true
          if( target.href && target.href.indexOf('https://www.a-management.eu') !== -1 ) internallink = true

          // handle only links that occur inside the component and do not reference external resources
          if ( internallink ) {
            // some sanity checks taken from vue-router:
            // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
            const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = $event
            // don't handle with control keys
            if (metaKey || altKey || ctrlKey || shiftKey) return
            // don't handle when preventDefault called
            if (defaultPrevented) return
            // don't handle right clicks
            if (button !== undefined && button !== 0) return
            
            // don't handle if `target="_blank"`
            /* 
            if (target && target.getAttribute) {
              const linkTarget = target.getAttribute('target')
              if (/\b_blank\b/i.test(linkTarget)) return
            }
            */
            
            // don't handle same page links/anchors
            const url = new URL(target.href)
            const to = url.pathname
            if (window.location.pathname !== to && $event.preventDefault) {
              $event.preventDefault()
              this.$router.push(to)
            }
            
          }
    
        },
        
//----------------------------------------------------------------------------        

        validateApiOutput(output){
          if( output.error && output.error == 'no-auth' ) {
						this.$store.dispatch('user_logout')
            window.location.reload()
						return false
          }
          return true
        },

      },

      mounted(){
        //console.log('mounted')
      },

  }

  mixins.something = {
    // data, computed, methods, created, otherhooks
  }

//------------------------------------------------------------------------------

  export default mixins



// WEBPACK FOOTER //
// ./src/mixins.js